// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__GMuMr","container":"styles_container__a4TT8","filterCategoryWrapper":"styles_filterCategoryWrapper__LzpXu"};